function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 72.5,
  cy: 72.5,
  r: 44.5,
  fill: "#192022"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95 72.5C95 84.9264 84.9264 95 72.5 95C60.0736 95 50 84.9264 50 72.5C50 60.0736 60.0736 50 72.5 50C84.9264 50 95 60.0736 95 72.5ZM82.1486 69.2947C82.5965 66.3008 80.3168 64.6913 77.1995 63.6177L78.2107 59.562L75.7418 58.9468L74.7574 62.8956C74.1083 62.7338 73.4416 62.5813 72.7793 62.4302L73.7708 58.4555L71.3032 57.8403L70.2914 61.8944C69.7541 61.772 69.2267 61.6511 68.7148 61.5239L68.7176 61.5112L65.3127 60.6611L64.6559 63.2978C64.6559 63.2978 66.4878 63.7176 66.4491 63.7435C67.4491 63.9931 67.6298 64.6548 67.5995 65.1792L66.4477 69.7995C66.5166 69.8171 66.6059 69.8424 66.7043 69.8817C66.6221 69.8613 66.5341 69.8388 66.4434 69.8171L64.8289 76.2893C64.7065 76.593 64.3964 77.0486 63.6974 76.8757C63.722 76.9115 61.9029 76.4278 61.9029 76.4278L60.6772 79.2536L63.8901 80.0545C64.4878 80.2043 65.0736 80.361 65.6502 80.5086L64.6284 84.6106L67.0946 85.2258L68.1064 81.1674C68.7604 81.3446 69.4163 81.5148 70.074 81.6779L69.0656 85.7173L71.5345 86.3325L72.5562 82.2382C76.7663 83.0349 79.9322 82.7135 81.2647 78.9061C82.3385 75.8405 81.2112 74.0722 78.9961 72.9191C80.6093 72.5473 81.8244 71.4863 82.1486 69.2947ZM76.5075 77.204C75.7445 80.2697 70.5824 78.6124 68.9088 78.1969L70.2646 72.7625C71.9381 73.1801 77.3049 74.007 76.5075 77.204ZM77.2712 69.2504C76.575 72.0389 72.2784 70.6222 70.8847 70.2749L72.1139 65.346C73.5077 65.6933 77.9962 66.3415 77.2712 69.2504Z",
  fill: "#E48B38"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95 72.5C95 84.9264 84.9264 95 72.5 95C60.0736 95 50 84.9264 50 72.5C50 60.0736 60.0736 50 72.5 50C84.9264 50 95 60.0736 95 72.5ZM82.1486 69.2947C82.5965 66.3008 80.3168 64.6913 77.1995 63.6177L78.2107 59.562L75.7418 58.9468L74.7574 62.8956C74.1083 62.7338 73.4416 62.5813 72.7793 62.4302L73.7708 58.4555L71.3032 57.8403L70.2914 61.8944C69.7541 61.772 69.2267 61.6511 68.7148 61.5239L68.7176 61.5112L65.3127 60.6611L64.6559 63.2978C64.6559 63.2978 66.4878 63.7176 66.4491 63.7435C67.4491 63.9931 67.6298 64.6548 67.5995 65.1792L66.4477 69.7995C66.5166 69.8171 66.6059 69.8424 66.7043 69.8817C66.6221 69.8613 66.5341 69.8388 66.4434 69.8171L64.8289 76.2893C64.7065 76.593 64.3964 77.0486 63.6974 76.8757C63.722 76.9115 61.9029 76.4278 61.9029 76.4278L60.6772 79.2536L63.8901 80.0545C64.4878 80.2043 65.0736 80.361 65.6502 80.5086L64.6284 84.6106L67.0946 85.2258L68.1064 81.1674C68.7604 81.3446 69.4163 81.5148 70.074 81.6779L69.0656 85.7173L71.5345 86.3325L72.5562 82.2382C76.7663 83.0349 79.9322 82.7135 81.2647 78.9061C82.3385 75.8405 81.2112 74.0722 78.9961 72.9191C80.6093 72.5473 81.8244 71.4863 82.1486 69.2947ZM76.5075 77.204C75.7445 80.2697 70.5824 78.6124 68.9088 78.1969L70.2646 72.7625C71.9381 73.1801 77.3049 74.007 76.5075 77.204ZM77.2712 69.2504C76.575 72.0389 72.2784 70.6222 70.8847 70.2749L72.1139 65.346C73.5077 65.6933 77.9962 66.3415 77.2712 69.2504Z",
  fill: "#E48B38"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  x: 0,
  y: 0,
  width: 145,
  height: 145,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 25,
  result: "effect1_foregroundBlur"
})));

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.703b7336.svg";
export { ForwardRef as ReactComponent };